import React, { useState, useEffect } from 'react'
import Dropzone from 'react-dropzone'
import { Line } from 'react-chartjs-2'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Button } from 'antd'
import moment from 'moment'

const OddsAnalyzer = (props) => {
  const [content, setContent] = useState([])
  const [runnerData, setRunnerData] = useState([])

  useEffect(() => {
    const userRole = localStorage.getItem('role')
    const loggedUserName = localStorage.getItem('userName')
    if (!userRole || !loggedUserName) {
      props.navigate('/login')
    }
  }, [])

  const handleFileDropped = async (file) => {
    let parsedContent = await new Blob(file).text()
    parsedContent = parsedContent.split('\n')
    parsedContent.pop()
    parsedContent = parsedContent.map((line) => JSON.parse(line))

    let mappedRunnerData = parsedContent[0].runners.map((r, index) => {
      return {
        labels: parsedContent.map((l, i) =>
          new Date(l.updateTime).toLocaleTimeString()
        ),
        datasets: [
          {
            label: 'Back',
            data: parsedContent.map(
              (l) => l.runners[index].ex.availableToBack[0].price
            ),
            fill: false,
            borderColor: '#b1d8fa',
          },
          {
            label: 'Lay',
            data: parsedContent.map(
              (l) => l.runners[index].ex.availableToLay[0].price
            ),
            fill: false,
            borderColor: '#f2cbd4',
          },
        ],
      }
    })

    setContent(parsedContent)
    setRunnerData(mappedRunnerData)
  }

  const getTextToBeCopied = (line, runnerIndex) => {
    const onBetObject = {
      time: moment(line.updateTime).format('MMM D, YYYY HH:mm:ss'),
      values: [
        ...[...line.runners[runnerIndex].ex.availableToBack].reverse(),
        ...line.runners[runnerIndex].ex.availableToLay,
      ],
    }
    return JSON.stringify(onBetObject)
  }

  return (
    <div className="analyzer-container">
      <Dropzone onDrop={handleFileDropped}>
        {({ getRootProps, getInputProps }) => (
          <section>
            <div
              {...getRootProps()}
              style={{
                padding: '5px 20px',
                background: '#f0f0f0',
                borderRadius: '8px',
                marginBottom: '20px',
              }}
            >
              <input {...getInputProps()} />
              <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
          </section>
        )}
      </Dropzone>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 180px)',
            overflowY: 'scroll',
            width: 340,
          }}
        >
          {content &&
            content.map((line, i) => (
              <div
                className="runner"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: 10,
                }}
                key={i}
              >
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    marginBottom: 4,
                    color: '#fff',
                  }}
                >
                  {new Date(line.updateTime).toLocaleString()}
                </div>
                {line.runners.map((r, runnerIndex) => (
                  <div style={{ display: 'flex' }}>
                    <div
                      className="analyzer-cell"
                      style={{
                        width: 100,
                        fontSize: 12,
                        color: '#fff',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        display: 'flex',
                        flexDirection: 'row',
                        background: '#433048',
                      }}
                    >
                      <span>{r.selectionId}</span>
                      <CopyToClipboard
                        text={getTextToBeCopied(line, runnerIndex)}
                      >
                        <Button
                          key={r.selectionId}
                          size="small"
                          className="copy"
                        >
                          Copy
                        </Button>
                      </CopyToClipboard>
                      {/* <span style={{color: "#65b457"}}>{r.totalMatched}</span> */}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        background: '#e6f3fd',
                      }}
                      className="back"
                    >
                      {r.ex.availableToBack.map((b) => (
                        <div className="analyzer-cell">
                          <span style={{ fontSize: 10 }}>{b.price}</span>
                          <span style={{ fontSize: 8 }}>{b.size}</span>
                        </div>
                      ))}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        background: '#fbeff2',
                      }}
                      className="lay"
                    >
                      {r.ex.availableToLay.map((l) => (
                        <div className="analyzer-cell">
                          <span style={{ fontSize: 10 }}>{l.price}</span>
                          <span style={{ fontSize: 8 }}>{l.size}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ))}
        </div>
        {runnerData && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 'calc(100vh - 180px)',
              overflowY: 'scroll',
            }}
          >
            {runnerData.map((data) => (
              <div style={{ marginBottom: '10px', color: '#fff' }}>
                <Line data={data} height="250" width="1000" />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default OddsAnalyzer
